import {
  AseAction,
  AseControl,
  AseFieldInstance as PHPAseFieldInstance,
  AseFieldResult,
} from 'types/Endpoints/AssessmentsPhp';
import { FieldResult } from 'types/types';
import { Action, AseFieldInstance, Control } from './types';
import {
  ensureFieldInstanceCheckAvailability,
  normaliseFieldInstanceChecks,
} from './utilities';

export const translateAction = (item: AseAction): Action => {
  return {
    id: item.id,
    reference: item.reference,
    customReference: item.customReference,
    photoIds: item.photoIds,
    previousParents: item.previousParents,
    timescaleId: item.timescaleId,
    severityId: item.severityId,
    quantity: item.quantity,
    questionId: item.questionId,
    suggestionId: item.suggestionId,
    sectionId: item.sectionId,
    where: item.where,
    why: item.why,
    fieldInstanceId: item.fieldInstanceId,
    description: item.description,
    dueDate: item.dueDate,
    dueDeterminedBy: item.dueDeterminedBy,
    dueTimescale: item.dueTimescale,
    dueTypeId: item.dueTypeId,
    complianceTypeId: item.complianceTypeId,
    complianceSubtypeId: item.complianceSubtypeId,
    categoryId: item.categoryId,
    assignedAccountIds: item.assignedAccountIds,
    assignedTeamIds: item.assignedTeamIds,
    history: item.history.map((history) => ({
      by: history.by,
      status: history.status,
      statusConfirmed: history.statusConfirmed,
      comment: history.comment,
      fileIds: history.fileIds,
      ts: history.ts,
    })),
    reviewNote: item.reviewNote,
    reviewStatusId: item.reviewStatusId,
    isReview: item.isReview,
    cost: item.cost,
    pin: item.pin,
  };
};

export const translateControl = (item: AseControl): Control => {
  return {
    id: item.id,
    photoIds: item.photoIds,
    fieldInstanceId: item.fieldInstanceId,
    suggestionId: item.suggestionId,
    previousParents: item.previousParents,
    questionId: item.questionId,
    sectionId: item.sectionId,
    reference: item.reference,
    description: item.description,
    why: item.why,
    where: item.where,
    history: item.history.map((history) => ({
      by: history.by,
      status: history.status,
      statusConfirmed: history.statusConfirmed,
      comment: history.comment,
      fileIds: history.fileIds,
      ts: history.ts,
    })),
    complianceTypeId: item.complianceTypeId,
    complianceSubtypeId: item.complianceSubtypeId,
    categoryId: item.categoryId,
    isReview: item.isReview,
    reviewNote: item.reviewNote,
    reviewStatusId: item.reviewStatusId,
  };
};

export const translateFieldResult = (item: AseFieldResult): FieldResult => ({
  fieldId: item.fieldId,
  value: item.value,
  pin: item.pin,
  ts: item.ts,
  action: item.action,
});

export const translateFieldResultNullable = (
  item: AseFieldResult,
): FieldResult => translateFieldResult(item as AseFieldResult) as FieldResult;

export const translateFieldRepeatableResultNullable = (
  item: PHPAseFieldInstance,
): AseFieldInstance => ({
  instanceId: item.instanceId,
  reference: item.reference,
  createdTs: item.createdTs,
  updatedTs: item.updatedTs,
  groupId: item.groupId,
  autoId: item.autoId,
  draftAutoId: item.draftAutoId,
  draft: item.autoId !== 0,
  action: item.action,
  results: Object.fromEntries(
    Object.entries(item.results).map(
      ([resultId, sItem]): [string, FieldResult] => [
        resultId,
        {
          fieldId: sItem.fieldId,
          value: sItem.value,
          pin: sItem.pin,
          ts: sItem.ts,
          action: sItem.action,
        },
      ],
    ),
  ),
  checks: normaliseFieldInstanceChecks(
    ensureFieldInstanceCheckAvailability(item.checks),
  ),
});
